// @flow

import React, { type Node } from 'react';
import { usePayment } from '../context';
import {
  Container,
  Content,
  TimeoutIcon,
  Title,
  Subtitle,
  RestartButton,
} from './timeout-screen.styles';

export function TimeoutScreen(): Node {
  const { dispatch } = usePayment();

  return (
    <Container>
      <Content>
        <TimeoutIcon>
          <TimeoutSvg />
        </TimeoutIcon>
        <Title>Su tiempo se acabó</Title>
        <Subtitle>El tiempo para aprobar la compra ha expirado.</Subtitle>
        <RestartButton onClick={() => dispatch({ type: 'RESTART_COLLECT_PHONE' })}>
          Volver e intentar nuevamente
        </RestartButton>
      </Content>
    </Container>
  );
}

export function TimeoutSvg(): Node {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="10" r="7.25" stroke="currentColor" strokeWidth="1.5" />
      <path d="M10 6.5V10.25L12.25 11.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M15.5 3.5L17.5 5.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M17.5 3.5L15.5 5.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}
